import { render, staticRenderFns } from "./noResult.vue?vue&type=template&id=bf795cae&scoped=true&"
import script from "./noResult.vue?vue&type=script&lang=js&"
export * from "./noResult.vue?vue&type=script&lang=js&"
import style0 from "./noResult.vue?vue&type=style&index=0&id=bf795cae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf795cae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf795cae')) {
      api.createRecord('bf795cae', component.options)
    } else {
      api.reload('bf795cae', component.options)
    }
    module.hot.accept("./noResult.vue?vue&type=template&id=bf795cae&scoped=true&", function () {
      api.rerender('bf795cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/noResult.vue"
export default component.exports